import { getUrl } from "aws-amplify/storage";
import fetchClient from "common/functions/fetcher";
import { MainContextContainer } from "components/Main";
import { useCallback, useContext, useEffect, useState } from "react";

export const useAboutHooks = () => {
  const mainContext = useContext(MainContextContainer);

  const [docs, setDocs] = useState<string[]>([]);

  const onCompanyAreasChange = useCallback(async () => {
    for (const key of [
      "docs/info.md",
      "docs/hazard.md",
      "docs/useDistrict.md",
      "docs/school.md",
      "docs/moj.md"
    ]) {
      const url = await getUrl({
        path: `public/${key}`
      })
        .then((value) => value.url.href)
        .catch(() => undefined);

      if (url) {
        const response = await fetchClient
          .get<string>(url, { responseType: "text" })
          .catch(() => undefined);

        if (response) {
          setDocs((x) => [...x, response.data]);
        }
      }
    }
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    onCompanyAreasChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    mainContext,
    docs,

    onCompanyAreasChange
  } as const;
};
